import { NgModule } from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ClipboardModule } from 'ngx-clipboard';

import { CopyTextComponent } from './copy-text.component';

@NgModule({
  imports: [
    ClipboardModule,
    InlineSVGModule,
  ],
  exports: [
    CopyTextComponent,
  ],
  declarations: [
    CopyTextComponent,
  ],
  providers: [],
})
export class CopyTextModule {
}
